<template>
    <card-list-item @action="action" :class="{'active': active}">
        <template v-slot:content>
            <div>Reflection Title</div>

            <div class="meta">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.<br>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.<br>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            </div>

            <div>
                <b-button variant="success" class="mt-3">Accept</b-button>
                <b-button variant="danger" class="ml-3 mt-3">Reject</b-button>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import Toolbar from "./common/Toolbar";
    import DataRow from "./common/DataRow";
    import CardListItem from "./common/CardListItem";

    export default {
        name: 'UserReflection',
        components: {CardListItem, DataRow, Toolbar},
        props: {
            card: {
                required: true
            },
            user: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                details: false,
            }
        },
        methods: {
            action: function () {
                this.$emit('action');
            },
            openCard: function (card, props) {
                this.$store.commit('openCard', {from: this.card, card: card, props: props});
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import '../assets/variables';

    li {
        padding: 0.4rem 0 0.7rem;

        .content {
            padding: 0.7rem 1.3rem 0.7rem 10px;

            .title {
                font-size: 0.95rem;
                font-weight: bold;
            }

            .meta {
                font-size: 0.8rem;
            }
        }

        .status-icons {
            margin-top: 0.3rem;
            font-size: 0.7rem;
            i {
                font-size: 0.65rem;
            }
        }

        .details {
            margin: 0.7rem 0 0.3rem;
        }
    }
</style>
